<template>
<svg version="1.1" id="Livello_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.078px"
	 height="319.839px" viewBox="619.639 -80.322 40.078 319.839" enable-background="new 619.639 -80.322 40.078 319.839"
	 xml:space="preserve">
<metadata>
	<sfw  xmlns="&ns_sfw;">
		<slices></slices>
		<sliceSourceBounds  height="319.839" width="40.078" y="380.983" x="939.264" bottomLeftOrigin="true"></sliceSourceBounds>
	</sfw>
</metadata>
<g>
	<polygon fill="#F29200" points="639.618,203.902 639.621,206.563 641.473,205.232 	"/>
	<polygon fill="#F29200" points="639.618,192.01 639.609,192.017 639.614,197.892 	"/>
	<polygon fill="#F29200" points="641.473,190.68 651.611,197.956 658.662,192.895 658.65,178.35 	"/>
</g>
<g>
	<polygon fill="#F29200" points="637.843,205.232 639.695,206.563 639.697,203.902 	"/>
	<polygon fill="#F29200" points="637.843,190.679 620.665,178.35 620.653,192.895 627.705,197.956 	"/>
	<polygon fill="#F29200" points="639.702,198.02 639.707,192.017 639.697,192.01 	"/>
</g>
<rect x="634.487" y="200.934" fill="#E6342A" width="9.417" height="38.583"/>
<polygon fill="#E6342A" points="639.695,192.35 639.707,206.895 620.665,220.563 620.653,206.017 "/>
<polygon fill="#E6342A" points="658.65,220.563 658.662,206.017 639.62,192.35 639.609,206.895 "/>
<g>
	<path fill="#11998E" d="M652.275,150.42l6.387,0.938v23.115c-2.344-0.371-8.994-1.191-19.951-2.461
		c-7.344-0.781-13.408-1.201-18.193-1.26v-8.115c1.915,0.332,7.979,1.094,18.193,2.285c5.879,0.625,10.547,1.191,14.004,1.699
		C652.715,161.992,652.568,156.592,652.275,150.42z"/>
	<path fill="#11998E" d="M636.953,111.338c6.035,0,11.338,1.938,15.908,5.815s6.855,8.755,6.855,14.634
		c0,4.453-1.641,8.13-4.922,11.03c-3.281,2.899-7.412,4.351-12.393,4.351c-6.094,0-11.411-1.953-15.952-5.859
		s-6.812-8.779-6.812-14.619c0-4.453,1.636-8.125,4.907-11.016C627.818,112.783,631.954,111.338,636.953,111.338z M637.51,119.102
		c-3.496,0-6.289,0.854-8.379,2.563c-2.09,1.71-3.135,3.854-3.135,6.432c0,3.398,1.641,6.123,4.922,8.174s6.885,3.076,10.811,3.076
		c3.496,0,6.295-0.85,8.394-2.549c2.1-1.699,3.149-3.838,3.149-6.416c0-3.379-1.66-6.104-4.98-8.174S641.377,119.102,637.51,119.102
		z"/>
	<path fill="#11998E" d="M639.678,76.768c1.387,0.215,4.414,0.605,9.082,1.172c2.207,0.234,5.176,0.381,8.906,0.439
		c1.191,4.707,1.787,8.545,1.787,11.514c0,5.82-1.67,10.215-5.01,13.184s-7.422,4.453-12.246,4.453
		c-6.328,0-11.611-2.168-15.85-6.504c-4.238-4.336-6.357-9.707-6.357-16.113c0-2.988,0.283-5.596,0.85-7.822l6.914,1.641
		c-0.801,2.813-1.201,5.381-1.201,7.705c0,4.063,1.436,7.271,4.307,9.624s6.406,3.53,10.605,3.53c3.379,0,6.235-0.933,8.569-2.798
		s3.501-4.536,3.501-8.013c0-1.055-0.117-2.305-0.352-3.75c-0.352,0.02-1.016,0.029-1.992,0.029c-0.918,0-2.646-0.073-5.186-0.22
		s-4.648-0.22-6.328-0.22V76.768L639.678,76.768z"/>
	<path fill="#11998E" d="M620.518,59.453c2.188,0.352,8.252,1.113,18.193,2.285c6.797,0.723,13.447,1.201,19.951,1.436v8.203
		c-2.754-0.43-9.404-1.27-19.951-2.52c-7.129-0.742-13.193-1.143-18.193-1.202V59.453L620.518,59.453z"/>
	<path fill="#11998E" d="M620.869,28.633l6.504,1.729c-0.957,2.383-1.436,5.029-1.436,7.939c0,4.707,1.426,7.061,4.277,7.061
		c1.113,0,2.08-0.508,2.9-1.523c0.743-0.898,1.689-2.646,2.842-5.245c2.676-6.015,6.494-9.023,11.455-9.023
		c8.203,0,12.305,5.635,12.305,16.904c0,3.536-0.449,6.788-1.348,9.755l-6.533-2.08c1.094-2.871,1.641-5.644,1.641-8.32
		c0-2.539-0.195-4.414-0.586-5.625c-0.684-2.148-2.012-3.223-3.984-3.223c-1.289,0-2.441,0.586-3.457,1.757
		c-0.918,1.055-2.041,2.988-3.369,5.801c-2.559,5.391-6.113,8.086-10.664,8.086c-4.063,0-6.997-1.396-8.804-4.189
		c-1.807-2.792-2.71-6.376-2.71-10.752C619.902,34.053,620.225,31.035,620.869,28.633z"/>
	<path fill="#11998E" d="M620.518-5.264l6.299,0.85c-0.293,3.691-0.439,7.168-0.439,10.43c1.777,0.234,5.889,0.693,12.334,1.377
		c7.559,0.801,14.209,1.299,19.951,1.494v8.086c-2.832-0.41-9.482-1.23-19.951-2.461c-4.434-0.469-8.545-0.859-12.334-1.172
		c0,2.617,0.156,6.23,0.469,10.84l-6.328-0.908V-5.264L620.518-5.264z"/>
	<path fill="#11998E" d="M620.518-18.77c2.188,0.351,8.252,1.113,18.193,2.285c6.797,0.723,13.447,1.201,19.951,1.436v8.203
		c-2.754-0.43-9.404-1.27-19.951-2.52c-7.129-0.742-13.193-1.143-18.193-1.201V-18.77L620.518-18.77z"/>
	<path fill="#11998E" d="M620.811-51.289l6.768,1.67c-0.742,2.109-1.113,4.17-1.113,6.182c0,3.926,1.445,7.007,4.336,9.243
		s6.338,3.354,10.342,3.354c3.32,0,6.123-0.942,8.408-2.827s3.428-4.624,3.428-8.218c0-2.305-0.42-4.873-1.26-7.705l6.738,1.201
		c0.664,3.105,0.996,5.742,0.996,7.91c0,5.899-1.703,10.318-5.112,13.257c-3.408,2.94-7.505,4.409-12.29,4.409
		c-6.211,0-11.44-2.109-15.688-6.328s-6.372-9.482-6.372-15.791C619.99-47.197,620.264-49.316,620.811-51.289z"/>
	<path fill="#11998E" d="M620.869-80.322l6.504,1.729c-0.957,2.383-1.436,5.029-1.436,7.939c0,4.707,1.426,7.061,4.277,7.061
		c1.113,0,2.08-0.508,2.9-1.523c0.743-0.898,1.689-2.646,2.842-5.244c2.676-6.016,6.494-9.024,11.455-9.024
		c8.203,0,12.305,5.635,12.305,16.904c0,3.536-0.449,6.788-1.348,9.756l-6.533-2.08c1.094-2.871,1.641-5.644,1.641-8.32
		c0-2.539-0.195-4.414-0.586-5.625c-0.684-2.148-2.012-3.223-3.984-3.223c-1.289,0-2.441,0.586-3.457,1.758
		c-0.918,1.055-2.041,2.988-3.369,5.8c-2.559,5.391-6.113,8.086-10.664,8.086c-4.063,0-6.997-1.396-8.804-4.19
		c-1.807-2.792-2.71-6.376-2.71-10.752C619.902-74.902,620.225-77.92,620.869-80.322z"/>
</g>
</svg>
</template>
<script>
import colors from "vuetify/es5/util/colors";
export default {
  name: "Logo",
  props: {
    size: {
      type: [String, Number],
      default: "50",
    },
    semiDark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseColor() {
      return this.$vuetify.theme.dark
        ? colors.grey.lighten5
        : this.semiDark
        ? colors.grey.lighten5
        : colors.grey.darken4;
    },
    primary() {
      //return this.$vuetify.theme.themes.light.primary.base;
      return colors.mygreen.lighten1
    },
  },
};
</script>
